import React from "react";
import FileOrFolderView from "views/library/file-or-folder-view/FileOrFolderView";
import MainPage from "views/library/main/MainPage";
import { useLibraryContext } from "./context/LibraryContext";

const LibraryViewSwitch = () => {
  const { currentFolderId } = useLibraryContext();
  return currentFolderId === "/" ? <MainPage /> : <FileOrFolderView />;
};

export default LibraryViewSwitch;
